import APICall from "../utils/APICall";

export default class AccountOfficerServices {
 
      static listAccountOfficer = async (page, pageLimit, search, from,to) => {
        return await APICall(`/api/AccountOfficer/admin/list-account-officers?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`, "GET");
    }
    static exportAccountOfficer = async (search, from,to) => {
        return await APICall(`/api/AccountOfficer/admin/list-account-officers?search=${search}&from=${from}&to=${to}`,"GET")
    }
    static viewAccountOfficer = async (misCode) => {
        return await APICall(`/api/AccountOfficer/admin/view-account-officer?misCode=${misCode}`, "GET")
    }
    static addAccountOfficer = async (payload) => {
        return await APICall("/api/AccountOfficer/admin/add-account-officer","POST", payload)
    }
    static editAccountOfficer = async (payload) => {
        return await APICall("/api/AccountOfficer/admin/edit-account-officer", "POST", payload)
    }
    static deleteOfficer = async (payload) => {
        return await APICall(`/api/AccountOfficer/admin/delete-account-officer`, "DELETE", payload)
    }
}